if (window.renderRecaptcha === undefined) {
    window.renderRecaptcha = function() {
        $('[data-recaptcha]').each(function(i, el) {
            $(this).attr('data-index', i);
            grecaptcha.render(el, {
                sitekey: el.dataset.sitekey,
                badge: el.dataset.badge,
                type: el.dataset.type,
                size: el.dataset.size,
                tabindex: el.dataset.tabindex,
                callback: el.dataset.callback,
            });
        });
    }
}